/**
 * utc8DayString — 返回 UTC+8 时区的日期串 YYYYMMDD。
 * 与后端 reward 的 ttlUntilNextDay（16:00 UTC = UTC+8 次日 00:00）日界一致，
 * 用于"VIP/创作者 每天一次域名验证码"的 localStorage 日键。
 */
export function utc8DayString(now: Date = new Date()): string {
  const utc8 = new Date(now.getTime() + 8 * 3600_000)
  const y = utc8.getUTCFullYear()
  const m = String(utc8.getUTCMonth() + 1).padStart(2, '0')
  const d = String(utc8.getUTCDate()).padStart(2, '0')
  return `${y}${m}${d}`
}
